import React, { useEffect, useState, useRef } from "react";
import moment from "moment";
import * as DinamicQueries from "../../api/DinamicsQuery";
import DataGrid, {
  Column,
  Paging,
  Pager,
  Toolbar,
  Item,
  Editing,
  SearchPanel,
  Selection,
  FilterRow,
  ColumnChooser,
} from "devextreme-react/data-grid";
import { Popup } from "devextreme-react/popup";
import ScrollView from "devextreme-react/scroll-view";
import { SelectBox } from "devextreme-react/select-box";
import { Button } from "devextreme-react/button";
import AsignarTipoServicioClientePopup from "./AsignarTipoServicioClientePopup";

const estatusOpciones = [
  { value: "Activo", text: "Activo" },
  { value: "Inactivo", text: "Inactivo" },
];

const serviceTypes = [
  { service_type: "Tradicional" },
  { service_type: "Moderno" },
];

const deliveryOpciones = [
  { value: true, text: "Habilitado" },
  { value: false, text: "Inhabilitado" },
];

const EdicionMultiplePopup = ({
  visible,
  onHide,
  establishmentData = [],
  onSaveSuccess,
  toastConfig,
  setToastConfig,
}) => {
  const [localData, setLocalData] = useState([]);
  const [saving, setSaving] = useState(false);
  const [canales, setCanales] = useState([]);
  const [cadenas, setCadenas] = useState([]);
  const [regiones, setRegiones] = useState([]);
  const [estados, setEstados] = useState([]);
  const [ciudades, setCiudades] = useState([]);
  const [parroquias, setParroquias] = useState([]);
  const [urbanizaciones, setUrbanizaciones] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [loadingFiltros, setLoadingFiltros] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const onSavingFiredRef = useRef(false);
  const [editorCanal, setEditorCanal] = useState(null);
  const [editorCadena, setEditorCadena] = useState(null);
  const [editorRegion, setEditorRegion] = useState(null);
  const [editorEstado, setEditorEstado] = useState(null);
  const [editorCiudad, setEditorCiudad] = useState(null);
  const [editorStatus, setEditorStatus] = useState(null);
  const [editorTipoServicio, setEditorTipoServicio] = useState(null);
  const [editorGeneralAbierto, setEditorGeneralAbierto] = useState(true);
  const gridRef = useRef(null);
  const [showTipoServicioClientePopup, setShowTipoServicioClientePopup] = useState(false);
  const [idsParaTipoServicioCliente, setIdsParaTipoServicioCliente] = useState([]);

  const buildEditorPatch = () => {
    const patch = {};
    const has = (obj) => obj && typeof obj === "object" && Object.keys(obj).length > 0;
    if (has(editorCanal)) {
      patch.nombre_canal = editorCanal.nombre_canal ?? "";
      patch.codigo_canal = editorCanal.codigo_canal ?? "";
      patch.uid_canal = editorCanal.key ?? "";
    }
    if (has(editorCadena)) {
      patch.nombre_cadena = editorCadena.nombre_cadena ?? "";
      patch.codigo_cadena = editorCadena.codigo_cadena ?? "";
      // En la colección cadenas el identificador es key; en el documento del establecimiento se guarda como uid_cadena
      patch.uid_cadena = editorCadena.key ?? "";
    }
    if (has(editorRegion)) {
      patch.nombre_region = editorRegion.nombre_region ?? "";
      patch.cod_region = editorRegion.cod_region ?? "";
      patch.uid_region = editorRegion.key ?? "";
    }
    if (has(editorEstado)) {
      patch.nombre_estado = editorEstado.nombre_estado ?? "";
      patch.codigo_estado = editorEstado.codigo_estado ?? "";
      patch.uid_estado = editorEstado.key ?? "";
    }
    if (has(editorCiudad)) {
      patch.nombre_ciudad = editorCiudad.nombre_ciudad ?? "";
      patch.codigo_ciudad = editorCiudad.codigo_ciudad ?? "";
      patch.uid_ciudad = editorCiudad.key ?? "";
    }
    if (editorStatus === "Activo" || editorStatus === "Inactivo") {
      patch.estatus = editorStatus;
    }
    if (editorTipoServicio && editorTipoServicio.service_type) {
      patch.tipo_servicio = editorTipoServicio.service_type;
    }
    return patch;
  };

  const showAllColumns = () => {
    const instance = gridRef.current?.instance;
    if (!instance) return;
    try {
      const columns = instance.option("columns") || [];
      columns.forEach((_, index) => {
        instance.columnOption(index, "visible", true);
      });
    } catch (e) {
      console.warn("showAllColumns:", e);
    }
  };

  const getFiltersData = () => {
    setLoadingFiltros(true);
    DinamicQueries.getData("getFilters", "EstablecimientosNuevos/")
      .then((resp) => {
        if (resp?.data && Array.isArray(resp.data)) {
          setRegiones(resp.data[1]?.regiones ?? []);
          setEstados(resp.data[2]?.estados ?? []);
          setCiudades(resp.data[3]?.ciudades ?? []);
          setParroquias(resp.data[4]?.parroquias ?? []);
          setUrbanizaciones(resp.data[5]?.urbanizaciones ?? []);
          setMunicipios(resp.data[6]?.municipios ?? []);
          setCanales(resp.data[7]?.canales ?? []);
          setCadenas(resp.data[8]?.cadenas ?? []);
        }
        setLoadingFiltros(false);
      })
      .catch(() => setLoadingFiltros(false));
  };

  useEffect(() => {
    if (visible && establishmentData && establishmentData.length > 0) {
      setLocalData(JSON.parse(JSON.stringify(establishmentData)));
    } else if (visible) {
      setLocalData([]);
    }
  }, [visible, establishmentData]);

  useEffect(() => {
    if (visible) {
      getFiltersData();
    }
  }, [visible]);

  useEffect(() => {
    if (visible && gridRef.current?.instance) {
      try {
        gridRef.current.instance.getController?.("editing")?.cancelEditData?.();
      } catch (_) {}
    }
  }, [visible]);

  const getLoginModify = () => {
    try {
      const stored = localStorage.getItem("userData");
      return stored ? JSON.parse(stored).nombre || "" : "";
    } catch (_) {
      return "";
    }
  };

  const sanitizeDataFinal = (obj) => {
    return Object.fromEntries(Object.entries(obj).filter(([, v]) => v !== undefined));
  };

  /**
   * Guardar: dos flujos separados.
   * 1) Si hay cambios en celdas del grid → solo se actualizan esas filas (sin editor ni selección).
   * 2) Si no hay cambios en el grid pero hay filas seleccionadas y valores en el editor → solo se actualizan esas filas con el editor.
   */
  const runGuardar = async (changes = []) => {
    const updates = (changes || []).filter((c) => c.type === "update");
    const editorPatch = buildEditorPatch();
    const hasGridChanges = updates.length > 0;
    const hasEditorSelection = selectedRowKeys.length > 0 && Object.keys(editorPatch).length > 0;

    if (hasGridChanges) {
      setSaving(true);
      let successCount = 0;
      let errorCount = 0;
      const fecha_modify = moment(new Date()).format("YYYY-MM-DD hh:mm:ss a");
      const login_modify = getLoginModify();

      for (const change of updates) {
        let patch = { ...change.data };
        if (
          patch.hasOwnProperty("nombre_cadena") &&
          (cadenas || []).length > 0
        ) {
          const cadena = cadenas.find(
            (c) => (c.nombre_cadena || "") === (patch.nombre_cadena || "")
          );
          if (cadena) {
            patch.codigo_cadena = cadena.codigo_cadena;
            patch.uid_cadena = cadena.key ?? "";
          }
        }
        const dataFinal = sanitizeDataFinal({
          key: change.key,
          ...patch,
          fecha_modify,
          login_modify,
        });
        if (!dataFinal.key) continue;
        try {
          await DinamicQueries.getDataWithParameters(
            "updateEstablishmentMultiple",
            "EstablecimientosNuevos/",
            { dataFinal }
          );
          successCount++;
        } catch (err) {
          console.error("Error al actualizar establecimiento:", change.key, err);
          errorCount++;
        }
      }

      setSaving(false);
      if (errorCount === 0) {
        setToastConfig({
          ...toastConfig,
          isVisible: true,
          type: "success",
          message: `Se actualizó ${successCount} establecimiento(s) correctamente`,
        });
        onSaveSuccess?.();
        onHide();
      } else {
        setToastConfig({
          ...toastConfig,
          isVisible: true,
          type: "warning",
          message: `Guardados: ${successCount}. Errores: ${errorCount}`,
        });
      }
      return;
    }

    if (hasEditorSelection) {
      setSaving(true);
      let successCount = 0;
      let errorCount = 0;
      const fecha_modify = moment(new Date()).format("YYYY-MM-DD hh:mm:ss a");
      const login_modify = getLoginModify();

      for (const key of selectedRowKeys) {
        const dataFinal = sanitizeDataFinal({
          key,
          ...editorPatch,
          fecha_modify,
          login_modify,
        });
        if (!dataFinal.key) continue;
        try {
          await DinamicQueries.getDataWithParameters(
            "updateEstablishmentMultiple",
            "EstablecimientosNuevos/",
            { dataFinal }
          );
          successCount++;
        } catch (err) {
          console.error("Error al actualizar establecimiento:", key, err);
          errorCount++;
        }
      }

      setSaving(false);
      if (errorCount === 0) {
        setToastConfig({
          ...toastConfig,
          isVisible: true,
          type: "success",
          message: `Se actualizó ${successCount} establecimiento(s) correctamente`,
        });
        onSaveSuccess?.();
        onHide();
      } else {
        setToastConfig({
          ...toastConfig,
          isVisible: true,
          type: "warning",
          message: `Guardados: ${successCount}. Errores: ${errorCount}`,
        });
      }
      return;
    }

    setToastConfig({
      ...toastConfig,
      isVisible: true,
      type: "info",
      message: "Edita una celda en la tabla o selecciona filas con el check y elige valores en el editor, luego Guardar.",
    });
  };

  const handleSaving = async (e) => {
    e.cancel = true;
    onSavingFiredRef.current = true;
    await runGuardar(e.changes || []);
  };

  const handleGuardarClick = () => {
    onSavingFiredRef.current = false;
    gridRef.current?.instance?.saveEditData();
    setTimeout(() => {
      if (!onSavingFiredRef.current) {
        runGuardar([]);
      }
    }, 200);
  };

  const formatearCoordenadas = (val) => {
    if (val == null || val === "") return "-";
    if (typeof val === "object" && (val.lat != null || val.lng != null)) {
      return `${val.lat ?? ""}, ${val.lng ?? ""}`;
    }
    return String(val);
  };

  const dropdownEditorOptions = { dropDownOptions: { width: 320 } };

  const renderEditableCell = (cellInfo) => {
    const val = cellInfo.value;
    const isEmpty =
      val === undefined || val === null || (typeof val === "string" && val.trim() === "");
    if (isEmpty) {
      return <span className="cell-empty-hint">Editar</span>;
    }
    const display =
      cellInfo.text != null ? cellInfo.text : (typeof val === "boolean" ? (val ? "Sí" : "No") : String(val));
    return <span>{display}</span>;
  };

  return (
    <Popup
      visible={visible}
      onHiding={onHide}
      showTitle={true}
      title="Edición Múltiple - Establecimientos"
      showCloseButton={true}
      fullScreen={true}
      wrapperAttr={{ class: "edicion-multiple-popup" }}
    >
      <style>{`
        /* Todas las celdas editables (excepto selección e ID/coordenadas): fondo suave, borde punteado, icono de edición fijo */
        .edicion-multiple-grid .dx-datagrid-rowsview .dx-data-row > td:not(.dx-command-select):not(.cell-readonly) {
          position: relative;
          cursor: text;
          background-color: #f5f7fb;
          border-bottom: 1px dashed #c8d2e4;
          transition: background-color 0.15s ease, opacity 0.15s ease;
        }

        .edicion-multiple-grid .dx-datagrid-rowsview .dx-data-row > td:not(.dx-command-select):not(.cell-readonly)::after {
          content: "✎";
          position: absolute;
          right: 8px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 11px;
          color: #8a9abc;
          opacity: 0.65; /* base */
          pointer-events: none;
          transition: opacity 0.15s ease;
        }

        /* Hover: mismo diseño pero un poco más marcado (más opacidad y leve cambio de fondo) */
        .edicion-multiple-grid .dx-datagrid-rowsview .dx-data-row > td:not(.dx-command-select):not(.cell-readonly):hover {
          background-color: #edf1fb;
        }

        .edicion-multiple-grid .dx-datagrid-rowsview .dx-data-row > td:not(.dx-command-select):not(.cell-readonly):hover::after {
          opacity: 1;
        }

        /* Mantener limpio el fondo cuando la fila está en modo edición */
        .edicion-multiple-grid .dx-datagrid-rowsview .dx-edit-row > td:not(.dx-command-select):not(.cell-readonly) {
          background-color: #ffffff;
          box-shadow: none;
        }

        .edicion-multiple-grid .cell-empty-hint {
          color: #8a9abc;
          font-style: italic;
          font-size: 0.9em;
        }
      `}</style>
      <ScrollView width="100%" height="100%">
        <div className="form-container p-3">
          <p className="text-muted small mb-3">
            <strong>Editor general (arriba):</strong> Marca con el check los establecimientos, elige solo los campos que quieras (Canal, Región, etc.) y Guardar. 
            <strong>Tabla:</strong> Edita celdas directamente; no hace falta marcar la fila. Un solo botón &quot;Guardar&quot; aplica ambos.
          </p>

          {/* Editor general: acordeón — aplica a los registros seleccionados (solo visual) */}
          <div
            className="editor-general mb-3"
            style={{
              border: "1px solid #e0e0e0",
              borderRadius: "8px",
              backgroundColor: "#fafafa",
              overflow: "hidden",
            }}
          >
            <div
              role="button"
              tabIndex={0}
              onClick={() => setEditorGeneralAbierto((v) => !v)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  setEditorGeneralAbierto((v) => !v);
                }
              }}
              className="d-flex align-items-center justify-content-between p-3"
              style={{
                fontWeight: 600,
                color: "#333",
                fontSize: "14px",
                cursor: "pointer",
                userSelect: "none",
              }}
            >
              <span>Editor general — Aplicar a seleccionados</span>
              <span
                style={{
                  display: "inline-block",
                  transition: "transform 0.2s ease",
                  transform: editorGeneralAbierto ? "rotate(180deg)" : "rotate(0deg)",
                }}
              >
                ▼
              </span>
            </div>
            {editorGeneralAbierto && (
              <div
                className="px-3 pb-3 pt-10"
                style={{ borderTop: "1px solid #e0e0e0" }}
              >
                <div
                  className="d-flex align-items-end"
                  style={{
                    flexWrap: "nowrap",
                    gap: "8px",
                    overflow: "hidden",
                  }}
                >
                  <div style={{ flex: "1 1 0", minWidth: 0 }}>
                    <label className="small text-muted d-block mb-1">Canal</label>
                    <SelectBox
                      placeholder="Canal"
                      showClearButton={true}
                      searchEnabled={true}
                      dataSource={canales}
                      displayExpr="nombre_canal"
                      value={editorCanal}
                      onValueChanged={(e) => setEditorCanal(e.value)}
                      disabled={loadingFiltros}
                    />
                  </div>
                  <div style={{ flex: "1 1 0", minWidth: 0 }}>
                    <label className="small text-muted d-block mb-1">Subcanal (Cadena)</label>
                    <SelectBox
                      placeholder="Cadena"
                      showClearButton={true}
                      searchEnabled={true}
                      dataSource={cadenas}
                      displayExpr="nombre_cadena"
                      value={editorCadena}
                      onValueChanged={(e) => setEditorCadena(e.value)}
                      disabled={loadingFiltros}
                    />
                  </div>
                  <div style={{ flex: "1 1 0", minWidth: 0 }}>
                    <label className="small text-muted d-block mb-1">Región</label>
                    <SelectBox
                      placeholder="Región"
                      showClearButton={true}
                      searchEnabled={true}
                      dataSource={regiones}
                      displayExpr="nombre_region"
                      value={editorRegion}
                      onValueChanged={(e) => setEditorRegion(e.value)}
                      disabled={loadingFiltros}
                    />
                  </div>
                  <div style={{ flex: "1 1 0", minWidth: 0 }}>
                    <label className="small text-muted d-block mb-1">Estado</label>
                    <SelectBox
                      placeholder="Estado"
                      showClearButton={true}
                      searchEnabled={true}
                      dataSource={estados}
                      displayExpr="nombre_estado"
                      value={editorEstado}
                      onValueChanged={(e) => setEditorEstado(e.value)}
                      disabled={loadingFiltros}
                    />
                  </div>
                  <div style={{ flex: "1 1 0", minWidth: 0 }}>
                    <label className="small text-muted d-block mb-1">Ciudad</label>
                    <SelectBox
                      placeholder="Ciudad"
                      showClearButton={true}
                      searchEnabled={true}
                      dataSource={ciudades}
                      displayExpr="nombre_ciudad"
                      value={editorCiudad}
                      onValueChanged={(e) => setEditorCiudad(e.value)}
                      disabled={loadingFiltros}
                    />
                  </div>
                  <div style={{ flex: "1 1 0", minWidth: 0 }}>
                    <label className="small text-muted d-block mb-1">Status</label>
                    <SelectBox
                      placeholder="Status"
                      showClearButton={true}
                      dataSource={estatusOpciones}
                      displayExpr="text"
                      valueExpr="value"
                      value={editorStatus}
                      onValueChanged={(e) => setEditorStatus(e.value)}
                    />
                  </div>
                  <div style={{ flex: "1 1 0", minWidth: 0 }}>
                    <label className="small text-muted d-block mb-1">Tipo de Servicio</label>
                    <SelectBox
                      placeholder="Tipo de Servicio"
                      showClearButton={true}
                      searchEnabled={true}
                      dataSource={serviceTypes}
                      displayExpr="service_type"
                      value={editorTipoServicio}
                      onValueChanged={(e) => setEditorTipoServicio(e.value)}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>

          <DataGrid
            ref={gridRef}
            className="edicion-multiple-grid"
            key={visible ? "edicion-multiple-open" : "edicion-multiple-closed"}
            dataSource={localData}
            keyExpr="key"
            showBorders={true}
            rowAlternationEnabled={true}
            columnAutoWidth={true}
            wordWrapEnabled={true}
            height="60vh"
            onSaving={handleSaving}
            onSelectionChanged={(e) => setSelectedRowKeys(e.selectedRowKeys || [])}
          >
            <Selection mode="multiple" />
            <Editing
              mode="batch"
              allowUpdating={true}
              allowAdding={false}
              allowDeleting={false}
            />
            <FilterRow visible={true} />
            <ColumnChooser enabled={true} mode="select" />
            <SearchPanel visible={true} width={240} placeholder="Buscar..." />
            <Paging defaultPageSize={100} />
            <Pager
              showPageSizeSelector={true}
              allowedPageSizes={[50, 100]}
              showInfo={true}
            />
            <Toolbar>
              <Item location="after" name="revertButton" />
              <Item location="after">
                <Button
                  text="Guardar"
                  type="default"
                  onClick={handleGuardarClick}
                  disabled={saving}
                  title="Guardar: cambios en celdas y/o aplicar editor a filas seleccionadas"
                />
              </Item>
              <Item location="after">
                <Button text="Todaslas Columnas" onClick={showAllColumns} title="Mostrar todas las columnas" />
              </Item>
              <Item location="after">
                <Button
                  text="Tipo servicio cliente"
                  onClick={() => {
                    const allIds = (localData || [])
                      .map((row) => row.ID)
                      .filter((id) => id != null && id !== "");

                    let ids = allIds;
                    if ((selectedRowKeys || []).length > 0) {
                      const selectedIds = selectedRowKeys
                        .map((gridKey) => {
                          const row = (localData || []).find((r) => r.key === gridKey);
                          return row ? row.ID : null;
                        })
                        .filter((id) => id != null && id !== "");
                      if (selectedIds.length > 0) {
                        ids = selectedIds;
                      }
                    }

                    console.log("IDs (columna ID) enviados a AsignarTipoServicioClientePopup:", ids);
                    setIdsParaTipoServicioCliente(ids);
                    setShowTipoServicioClientePopup(true);
                  }}
                  title="Asignar tipo de servicio por cliente"
                />
              </Item>
              <Item name="columnChooserButton" />
            </Toolbar>

            <Column
              caption="ID"
              dataField="ID"
              width={100}
              allowEditing={false}
              cssClass="cell-readonly"
            />
            <Column
              caption="Nombre"
              dataField="nombre_establecimiento"
              dataType="string"
              width={220}
              cellRender={renderEditableCell}
            />
            <Column
              caption="Dirección del establecimiento"
              dataField="direccion"
              dataType="string"
              width={220}
              cellRender={renderEditableCell}
            />
            <Column
              caption="Tipo de Servicio"
              dataField="tipo_servicio"
              dataType="string"
              width={140}
              lookup={{
                dataSource: serviceTypes,
                displayExpr: "service_type",
                valueExpr: "service_type",
              }}
              editorOptions={dropdownEditorOptions}
              cellRender={renderEditableCell}
            />
            <Column
              caption="Cadena"
              dataField="nombre_cadena"
              dataType="string"
              width={140}
              lookup={{
                dataSource: cadenas,
                displayExpr: "nombre_cadena",
                valueExpr: "nombre_cadena",
              }}
              editorOptions={dropdownEditorOptions}
              setCellValue={(rowData, value) => {
                const cadena = (cadenas || []).find(
                  (c) => (c.nombre_cadena || "") === (value || "")
                );
                if (cadena) {
                  rowData.nombre_cadena = cadena.nombre_cadena ?? "";
                  rowData.codigo_cadena = cadena.codigo_cadena;
                  rowData.uid_cadena = cadena.key ?? "";
                } else {
                  rowData.nombre_cadena = value ?? "";
                  rowData.codigo_cadena = undefined;
                  rowData.uid_cadena = "";
                }
              }}
              cellRender={renderEditableCell}
            />
            <Column
              caption="Canal"
              dataField="nombre_canal"
              dataType="string"
              width={140}
              lookup={{
                dataSource: canales,
                displayExpr: "nombre_canal",
                valueExpr: "nombre_canal",
              }}
              editorOptions={dropdownEditorOptions}
              cellRender={renderEditableCell}
            />
            <Column
              caption="Región"
              dataField="nombre_region"
              dataType="string"
              width={140}
              lookup={{
                dataSource: regiones,
                displayExpr: "nombre_region",
                valueExpr: "nombre_region",
              }}
              editorOptions={dropdownEditorOptions}
              cellRender={renderEditableCell}
            />
            <Column
              caption="Estado"
              dataField="nombre_estado"
              dataType="string"
              width={140}
              lookup={{
                dataSource: estados,
                displayExpr: "nombre_estado",
                valueExpr: "nombre_estado",
              }}
              editorOptions={dropdownEditorOptions}
              cellRender={renderEditableCell}
            />
            <Column
              caption="Ciudad"
              dataField="nombre_ciudad"
              dataType="string"
              width={140}
              lookup={{
                dataSource: ciudades,
                displayExpr: "nombre_ciudad",
                valueExpr: "nombre_ciudad",
              }}
              editorOptions={dropdownEditorOptions}
              cellRender={renderEditableCell}
            />
            <Column
              caption="Parroquia"
              dataField="nombre_parroquia"
              dataType="string"
              width={140}
              lookup={{
                dataSource: parroquias,
                displayExpr: "nombre_parroquia",
                valueExpr: "nombre_parroquia",
              }}
              editorOptions={dropdownEditorOptions}
              cellRender={renderEditableCell}
            />
            <Column
              caption="Código Postal"
              dataField="codigo_postal"
              dataType="string"
              width={140}
              cellRender={renderEditableCell}
            />
            <Column
              caption="Urbanización"
              dataField="nombre_urbanizacion"
              dataType="string"
              width={140}
              lookup={{
                dataSource: urbanizaciones,
                displayExpr: "nombre_urbanizacion",
                valueExpr: "nombre_urbanizacion",
              }}
              editorOptions={dropdownEditorOptions}
              cellRender={renderEditableCell}
            />
            <Column
              caption="Razón Social"
              dataField="razon_social"
              dataType="string"
              width={180}
              cellRender={renderEditableCell}
            />
            <Column
              caption="RIF"
              dataField="rif"
              dataType="string"
              width={140}
              cellRender={renderEditableCell}
            />
            
            <Column
              caption="Teléfono"
              dataField="telefonos"
              dataType="string"
              width={140}
              cellRender={renderEditableCell}
            />
            <Column
              caption="Nombre de Gerente"
              dataField="nombre_gerente"
              dataType="string"
              width={140}
              cellRender={renderEditableCell}
            />
            
            <Column
              caption="Oficina"
              dataField="nombre_oficina"
              dataType="string"
              width={140}
              cellRender={renderEditableCell}
            />
            <Column
              caption="Cantidad de Cajas"
              dataField="cant_cajas"
              dataType="string"
              width={140}
              cellRender={renderEditableCell}
            />
            {/* <Column
              caption="Código Polar / P&G"
              dataField="nombre_region"
              dataType="string"
              width={140}
            />
            <Column
              caption="Región Polar / P&G"
              dataField="nombre_region"
              dataType="string"
              width={140}
            /> */}
            <Column
              caption="Región Stmartiz"
              dataField="region_stmoritz"
              dataType="string"
              width={140}
              cellRender={renderEditableCell}
            /> 
            <Column
              caption="Estatus"
              dataField="estatus"
              width={120}
              allowSorting={false}
              lookup={{
                dataSource: estatusOpciones,
                displayExpr: "text",
                valueExpr: "value",
              }}
              editorOptions={dropdownEditorOptions}
              cellRender={renderEditableCell}
            />
            <Column
              caption="Delivery"
              dataField="delivery"
              dataType="boolean"
              width={140}
              lookup={{
                dataSource: deliveryOpciones,
                displayExpr: "text",
                valueExpr: "value",
              }}
              editorOptions={dropdownEditorOptions}
              cellRender={renderEditableCell}
            />
            {/* <Column
              caption="Métodos de pago"
              dataField="metodos_pago"
              dataType="string"
              width={140}
            /> */}
            {/* <Column
              caption="Secciones"
              dataField="secciones"
              dataType="string"
              width={140}
            /> */}
            <Column
              caption="Verificado"
              dataField="revisado"
              dataType="boolean"
              width={100}
              allowSorting={false}
              cellRender={renderEditableCell}
            />
            <Column
              caption="Coordenadas"
              dataField="coordenadas"
              width={160}
              allowEditing={false}
              cssClass="cell-readonly"
              cellRender={(cellInfo) => (
                <span>{formatearCoordenadas(cellInfo.value)}</span>
              )}
            />
          </DataGrid>
          <AsignarTipoServicioClientePopup
            visible={showTipoServicioClientePopup}
            onClose={() => setShowTipoServicioClientePopup(false)}
            establishmentIds={idsParaTipoServicioCliente}
          />
        </div>
      </ScrollView>
    </Popup>
  );
};

export default EdicionMultiplePopup;
